import { JobTitle } from './v4';

export type SystemMessage = {
  functions: JobTitle[];
  settings?: {
    minTimePassed?: number;
    minUpdateDifference?: number;
    timeBefore?: number;
  };
};

export type SystemMessageConfiguration = {
  [key in MessageType]: SystemMessage;
};

export enum MessageType {
  SYSTEM_AIRCRAFT_CHANGE = 'SYSTEM_AIRCRAFT_CHANGE',
  SYSTEM_CREW_CHANGE = 'SYSTEM_CREW_CHANGE',
  SYSTEM_FFD_SIGNED = 'SYSTEM_FFD_SIGNED',
  SYSTEM_FLIGHT_DELAY = 'SYSTEM_FLIGHT_DELAY',
  SYSTEM_FLIGHT_DELAY_NEW_ETA = 'SYSTEM_FLIGHT_DELAY_NEW_ETA',
  SYSTEM_GATE_UPDATE = 'SYSTEM_GATE_UPDATE',
  SYSTEM_LOADSHEET_ACCEPTED = 'SYSTEM_LOADSHEET_ACCEPTED',
  SYSTEM_LOADSHEET_CREATED = 'SYSTEM_LOADSHEET_CREATED',
  SYSTEM_LOADSHEET_SUBMITTED = 'SYSTEM_LOADSHEET_SUBMITTED',
  SYSTEM_OFP_COMPLETED = 'SYSTEM_OFP_COMPLETED',
  SYSTEM_OFP_RELEASED = 'SYSTEM_OFP_RELEASED',
  SYSTEM_TIME_UPDATE_ALDT = 'SYSTEM_TIME_UPDATE_ALDT',
  SYSTEM_TIME_UPDATE_ATA = 'SYSTEM_TIME_UPDATE_ATA',
  SYSTEM_TIME_UPDATE_ATOT = 'SYSTEM_TIME_UPDATE_ATOT',
  SYSTEM_TIME_UPDATE_NEW_CTOT = 'SYSTEM_TIME_UPDATE_NEW_CTOT',
  SYSTEM_TIME_UPDATE_NEW_ELDT = 'SYSTEM_TIME_UPDATE_NEW_ELDT',
  SYSTEM_TIME_UPDATE_NEW_ETA = 'SYSTEM_TIME_UPDATE_NEW_ETA',
  SYSTEM_TIME_UPDATE_NEW_ETD = 'SYSTEM_TIME_UPDATE_NEW_ETD',
  SYSTEM_TIME_UPDATE_NEW_ETOT = 'SYSTEM_TIME_UPDATE_NEW_ETOT',
  SYSTEM_TIME_UPDATE_OUT = 'SYSTEM_TIME_UPDATE_OUT',
}
